module.exports = __webpack_public_path__ + "img/broadcast-pin.420fb01d.svg";